/** Single CCS Spotlight story — shareable page at /spotlight/:id. */
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import SpotlightArticle from "@/components/spotlight/SpotlightArticle";
import LegalFooter from "@/components/brand/LegalFooter";
import NominationDialog from "@/components/spotlight/NominationDialog";
import { SpotlightHeader, NominationCTA } from "@/pages/SpotlightPage";

export default function SpotlightArticlePage() {
  const { spotlightId } = useParams();
  const [spotlight, setSpotlight] = useState(null);
  const [status, setStatus] = useState("loading");
  const [nominateOpen, setNominateOpen] = useState(false);

  useEffect(() => {
    setStatus("loading");
    api
      .get(`/public/spotlights/${spotlightId}`)
      .then((r) => {
        setSpotlight(r.data);
        setStatus("ready");
        window.scrollTo(0, 0);
      })
      .catch(() => setStatus("notfound"));
  }, [spotlightId]);

  return (
    <div className="min-h-screen bg-[#FDFBF5]" data-testid="spotlight-article-page">
      <SpotlightHeader />
      <main className="max-w-7xl mx-auto px-6 sm:px-12 py-14 sm:py-20">
        <Link
          to="/spotlight"
          className="inline-flex items-center gap-2 text-sm text-[#6B5944] hover:text-[#5D3A1F] mb-10 transition-colors"
          data-testid="back-to-spotlights"
        >
          <ArrowLeft size={15} strokeWidth={1.5} /> All Spotlights
        </Link>

        {status === "loading" && <div className="py-24 text-center text-[#6B5944]">Loading…</div>}
        {status === "notfound" && (
          <div className="py-24 text-center" data-testid="spotlight-not-found">
            <p className="text-[#6B5944]">This Spotlight could not be found.</p>
            <Link to="/spotlight" className="inline-block mt-4 text-[#C28A2E] font-semibold hover:underline">
              Browse all Spotlights
            </Link>
          </div>
        )}
        {status === "ready" && spotlight && (
          <>
            <SpotlightArticle spotlight={spotlight} onNominate={() => setNominateOpen(true)} />
            <div className="mt-20">
              <NominationCTA onNominate={() => setNominateOpen(true)} />
            </div>
          </>
        )}
      </main>
      <footer className="border-t border-[#EBE3D2] py-10 px-6 text-center">
        <p className="text-xs italic text-[#8B5A2B]">"Let everything you do be done in love." — 1 Corinthians 16:14</p>
        <LegalFooter className="mt-6" />
      </footer>
      <NominationDialog open={nominateOpen} onOpenChange={setNominateOpen} />
    </div>
  );
}
